// TMDB images are paths, not files (CLAUDE.md: Images are paths, not files).
// We store the path and serve from their CDN at the size the layout needs —
// never downloaded, re-hosted or resized by us.
export function tmdbImage(path: string | null, size: string): string | null {
  return path ? `https://image.tmdb.org/t/p/${size}${path}` : null;
}
